import React , { useState } from "react";

import { useIntl } from "react-intl";
import { Container, CustomDragger } from "./styles";

const Dragger = ({
  name,
  rules,
  label,
  maxCount = 1,
  accept = "application/pdf",
  type= "PDF",
}) => {
  const [fileList, setFileList] = useState([]);
  const intl = useIntl();

  const handleChange = (info) => {
    const fileListCount = maxCount * -1;

    let newFileList = [...info.fileList];
    newFileList = newFileList.slice(fileListCount);

    setFileList(newFileList);
  };

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    onChange: handleChange,
    fileList,
  };

  return (
    <Container
      name={name}
      rules={rules}
      label={label}
    >
      <CustomDragger
        maxCount={maxCount}
        accept={accept}
        {...props}
      >
        <p className="ant-upload-text">
            {intl.formatMessage(
              { id: "drag_and_drop_sheet_message" },
              { filetype: type }
            )}
        </p>
      </CustomDragger>
    </Container>
  );
};

export default Dragger;
